import React, { CSSProperties, ReactNode } from "react";
import styles from "./flex-row-container.module.scss";

const cssClassName = "flex-row-container";

interface FlexRowContainerProps {
  horizontalGap?: number;
  justifyContent?:
    | "flex-start"
    | "center"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "space-evenly";
  children: ReactNode;
}

export const FlexRowContainer = ({
  horizontalGap = 8,
  justifyContent = "flex-start",
  children,
}: FlexRowContainerProps) => {
  const styleVars = {
    "--horizontal-gap": `${horizontalGap}px`,
    "--justify-content": justifyContent,
  } as CSSProperties;

  return (
    <div className={styles[cssClassName]} style={styleVars}>
      {children}
    </div>
  );
};
